import { render, staticRenderFns } from "./PayerVindication.vue?vue&type=template&id=908a6bc6&scoped=true"
import script from "./PayerVindication.vue?vue&type=script&lang=js"
export * from "./PayerVindication.vue?vue&type=script&lang=js"
import style0 from "./PayerVindication.vue?vue&type=style&index=0&id=908a6bc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908a6bc6",
  null
  
)

export default component.exports